import React, { useRef } from 'react';
import FusionGrid from 'fusiongrid';
import { ReactFusionGrid } from 'react-fusiongrid';
import 'fusiongrid/dist/fusiongrid.css';
import './FGrid.css';
import AddIcon from '@mui/icons-material/Add';
import { Button } from "@material-ui/core";
import CircularProgress from "@mui/material/CircularProgress";



ReactFusionGrid.fgRoot(FusionGrid);

const gridConfig = {
  layout: { density: 'compact', autoHeight: false },
  rowOptions: {
    style: { backgroundColor: 'oldlace', fontFamily: 'Nunito Sans, sans-serif !important' },
    hover: {
      enable: true,
      style: { backgroundColor: 'white' },
    },
  },
  columns:[
    {
      field: 'company_name',
      headerText: 'COMPANY',
      width: 200,
      headerStyle: {
        "font-family": "Nunito Sans, sans-serif",
        "font-weight":700
      },
      hover: {
        enable: true,
        class: 'onHover',
      },
      tooltip: {
        enableCellTooltip: true, // Enable tooltip for the cell
        enableHeaderTooltip: false,
        cellTooltip: function (params) {
          return `<div style='font-weight: 700'>${params['cellValue']}</div>`;
        },
      },
    },
    
    {
      field: 'source',
      headerText: 'SOURCES',
      width: 200,
      headerStyle: {
        "font-family": "Nunito Sans, sans-serif",
        "font-weight":700
      },
      hover: {
        enable: true,
        class: 'onHover',
      },
      tooltip: {
        enableCellTooltip: true, // Enable tooltip for the cell
        enableHeaderTooltip: false,
        cellTooltip: function (params) {
          return `<div style='font-weight: 700'>${params['cellValue']}</div>`;
        },
      },
    },

    {
      field: 'page_visits',
      headerText: 'VISITED WEBPAGES',
      width: 200,
      headerStyle: {
        "font-family": "Nunito Sans, sans-serif",
        "font-weight":700
      },
      hover: {
        enable: true,
        class: 'onHover',
      },
      tooltip: {
        enableCellTooltip: true, // Enable tooltip for the cell
        enableHeaderTooltip: false,
        cellTooltip: function (params) {
          return `<div style='font-weight: 700'>${params['cellValue']}</div>`;
        },
      },
    },
      {
        field: 'company_website',
        headerText: 'ACCOUNT DOMAIN',
        width: 200,
        headerStyle: {
          "font-family": "Nunito Sans, sans-serif",
          "font-weight":700
        },
        hover: {
          enable: true,
          class: 'onHover',
        },
        tooltip: {
          enableCellTooltip: true, // Enable tooltip for the cell
          enableHeaderTooltip: false,
          cellTooltip: function (params) {
            return `<div style='font-weight: 700'>${params['cellValue']}</div>`;
          },
        },
      },
      {
        field: 'company_size_range',
        headerText: 'COMPANY SIZE',
        width: 200,
        headerStyle: {
          "font-family": "Nunito Sans, sans-serif",
          "font-weight":700
        },
        hover: {
          enable: true,
          class: 'onHover',
        },
        tooltip: {
          enableCellTooltip: true, // Enable tooltip for the cell
          enableHeaderTooltip: false,
          cellTooltip: function (params) {
            return `<div style='font-weight: 700'>${params['cellValue']}</div>`;
          },
        },
      },
      {
        field: 'surging_country',
        headerText: 'COUNTRY',
        width: 200,
        headerStyle: {
          "font-family": "Nunito Sans, sans-serif",
          "font-weight":700
        },
        hover: {
          enable: true,
          class: 'onHover',
        },
        tooltip: {
          enableCellTooltip: true, // Enable tooltip for the cell
          enableHeaderTooltip: false,
          cellTooltip: function (params) {
            return `<div style='font-weight: 700'>${params['cellValue']}</div>`;
          },
        },
      },
        {
          field: 'company_industry',
          headerText: 'COMPANY INDUSTRY',
          width: 200,
          headerStyle: {
            "font-family": "Nunito Sans, sans-serif",
            "font-weight":700
          },
          hover: {
            enable: true,
            class: 'onHover',
          },
          tooltip: {
            enableCellTooltip: true, // Enable tooltip for the cell
            enableHeaderTooltip: false,
            cellTooltip: function (params) {
              return `<div style='font-weight: 700'>${params['cellValue']}</div>`;
            },
          },
        },
              {
                field: 'topics_data',
                headerText: 'TOPICS',
                width: 200,
                headerStyle: {
                  "font-family": "Nunito Sans, sans-serif",
                  "font-weight":700
                },
                hover: {
                  enable: true,
                  class: 'onHover',
                },
                tooltip: {
                  enableCellTooltip: true, // Enable tooltip for the cell
                  enableHeaderTooltip: false,
                  cellTooltip: function (params) {
                    return `<div style='font-weight: 700'>${params['cellValue']}</div>`;
                  },
                },
              },
                {
                  field: 'intent_creation_date',
                  headerText: 'LAST INTENT DATE',
                  width: 200,
                  headerStyle: {
                    "font-family": "Nunito Sans, sans-serif",
                    "font-weight":700
                  },
                  hover: {
                    enable: true,
                    class: 'onHover',
                  },
                },
                {
                  field: 'source_details',
                  headerText: 'ACTIVITIES',
                  width: 200,
                  headerStyle: {
                    "font-family": "Nunito Sans, sans-serif",
                    "font-weight":700
                  },
                  hover: {
                    enable: true,
                    class: 'onHover',
                  },
                  tooltip: {
                    enableCellTooltip: true, // Enable tooltip for the cell
                    enableHeaderTooltip: false,
                    cellTooltip: function (params) {
                      return `<div style='font-weight: 700'>${params['cellValue']}</div>`;
                    },
                  },
                },
  ],
  defaultColumnOptions: {
    searchable: true,
    width: 10,
    filter: {
      enable: true,
      type: 'conditional',
    },
    sortable: true,
  },
  pagination: {
    showPages: {
      enable: true,
      showTotal: true,
    },
    showRecordCount: true,
    pageSize: {
      default:15,
      options: [15,100,1000],
    },
  },
};

const FGrid = ({data, schema}) => {
  const gridRef = useRef(null);
  const dataStore = new FusionGrid.DataStore();
  const dataTable = dataStore.createDataTable(data, schema, {
    enableIndex: false,
  });
  const getDataForDownload = () => {
    gridRef.current.grid.export({ format: 'csv', mode: 'view' });
  };

  return (
    <>
      <div id="grid_container_main" style={{display:"flex", flexDirection:"column", marginTop:"5px"}}>
        {
          (data && data?.length) > 0 && 
          <>
            <div id="fgrid_id">
              <ReactFusionGrid
                ref={gridRef}
                width={"100%"}
                height={"485px"}
                data={dataTable}
                config={gridConfig}
              />
            </div>
            <div style={{ position:"sticky", bottom:0 }}>
              <div style={{ display: "flex", width: 'inherit', paddingTop: "0px", justifyContent: "flex-end", marginLeft: '2em', marginBottom:'10px' }}>
                <Button
                  variant="outlined"
                  textTransform="none"
                  onClick={getDataForDownload}
                  style={{
                    marginLeft: '26px',
                    textTransform: 'none',
                    borderRadius: '32px',
                    color: '#21DA8C',
                    fontWeight: '700',
                    height: '32px',
                    border: '1px solid #21DA8C',
                  }}
                  startIcon={<AddIcon />}
                >
                  Download
                </Button>                   
              </div> 
            </div>
            
          </>
        }
      </div>
        {
          !(data && data?.length > 0) &&      <div style={{display: "flex", paddingTop:"198px",
            alignItems: "center",
            justifyContent: "center"}}> <CircularProgress style={{ color: "#016B40" }} /> </div> 
        }
    </>
  );
};

export default FGrid;


